import React from "react";
import "./GraphicDesign.css";

const GraphicDesign = () => {
  return (
    <div>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
      <p>this is GraphicDesign</p>
    </div>
  );
};

export default GraphicDesign;
